<!--
   Created by qing on 2021/3/11
   Des: 
-->
<template>
  <div>
    <van-cell class="mult-line-container" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">
        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>

        <div
          v-if="isRead"
          class="readonly-input"
          style='white-space: pre-wrap;'
          v-html="content">
        </div>

        <van-field
          v-if="!isRead"
          rows="3"
          type="textarea"
          :readonly="isReadOnly"
          @change="controlChange"
          v-model="currentRow[dataId]"
          :placeholder="current.fieldDes"
          :error-message="errorMessage">
        </van-field>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact mult-line-container-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>

          <div
            v-if="isRead"
            class="readonly-input"
            style='white-space: pre-wrap;'
            v-html="content">
          </div>

          <van-field
            v-else
            class="mult-line-input"
            rows="3"
            type="textarea"
            :readonly="isReadOnly"
            @change="controlChange"
            :placeholder="isReadOnly ? '暂无内容' : '请填写内容'"
            v-model="currentRow[dataId]">
          </van-field>
        </template>
      </van-field>

    </div>
  </div>
</template>

<script>
  import {current} from './mixin'
  import {selectPhoneNumberAndUrl} from "../../../../assets/js/Untis";

  export default {
    mixins: [current],
    data() {
      return {
        isError: false
      }
    },
    computed: {
      content() {
        const value = selectPhoneNumberAndUrl(this.currentRow[this.dataId])
        return this.currentRow[this.dataId] ? value : '暂无内容'
      },
      checkList() {
        return this.current.checkList()
      },
      errorMessage() {
        return this.isError ? '输入数据不合法' : ''
      }
    },
    methods: {
      inputBlur() {
        this.isError = this.current.checkMissValue && (!this.current.checkWriteValue() || !this.checkList)
      }
    }
  }
</script>

<style lang="less">

  .mult-line-container {

    .van-field {
      height: 82px !important;

      .van-field__body {
        height: 82px !important;
      }

      .van-field__control {
        margin: 5px 0 !important;
      }
    }

    .readonly-input {
      word-break: break-word;

      .el-textarea__inner {
        padding: 0;
        border: none;
      }

      textarea {
        padding-bottom: 0;
        width: 100%;
        border: none;
        outline: none;
        resize: none;
        overflow: hidden;
        background-color: inherit;
      }
    }

    /*.readonly-input {*/
    /*  height: auto !important;*/
    /*  border: none;*/

    /*  .van-field__body {*/
    /*    height: auto !important;*/

    /*    textarea {*/
    /*      padding-bottom: 0;*/
    /*      width: 100%;*/
    /*      border: none;*/
    /*      outline: none;*/
    /*      resize: none;*/
    /*      overflow: hidden;*/
    /*      background-color: inherit;*/
    /*    }*/
    /*  }*/
    /*}*/
  }

  .mult-line-container-compact {

    .mult-line-input {
      padding: 0 !important;
    }

    .readonly-input {
      word-break: break-word;

      .el-textarea__inner {
        padding: 0;
        border: none;
        font-size: 14px;
      }

      textarea {
        padding-bottom: 0;
        width: 100%;
        border: none;
        outline: none;
        resize: none;
        overflow: hidden;
        background-color: inherit;
      }
    }
  }
</style>